import React, { useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import {Img} from '../UI/UI';

import './HolylandYoutube.css';

export const HolylandYoutube = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);

  // Sample video data
  const videos = [
    {
        id: "1iz5zwLCKT0",
        description: "City of David", 
        thumbnail:"https://img.youtube.com/vi/1iz5zwLCKT0/maxresdefault.jpg"
      },
      {
        id: "h4bjtidVRfk",
        description: "Path of the Patriarchs",
        thumbnail:"https://img.youtube.com/vi/h4bjtidVRfk/maxresdefault.jpg"
      },
      {
        id: "ikjza61EnGg",
        description: "Tomb of the Patriarchs",
        thumbnail:"https://img.youtube.com/vi/ikjza61EnGg/maxresdefault.jpg"
      },
      {
        id: "Us6lzdPdy08",
        description: "Tel Azekah",
        thumbnail:"https://img.youtube.com/vi/Us6lzdPdy08/maxresdefault.jpg"
      },
      {
        id: "_H0szpxa8Do",
        description: "Neot Qedumim",
        thumbnail:"https://img.youtube.com/vi/_H0szpxa8Do/maxresdefault.jpg"
      },
      {
        id: "cVaZUePphcw",
        description: "The Hula Valley",
        thumbnail:"https://img.youtube.com/vi/cVaZUePphcw/maxresdefault.jpg"
      },
      {
        id: "lvEBeBGQ5tM",
        description: "Ancient Katzrin",
        thumbnail:"https://img.youtube.com/vi/lvEBeBGQ5tM/maxresdefault.jpg"
      },
      {
        id: "EsDLwkvyRr4",
        description: "Qumran",
        thumbnail:"https://img.youtube.com/vi/EsDLwkvyRr4/maxresdefault.jpg"
      },
      {
        id: "Z6CpE0iTvp0",
        description: "Making the Desert Bloom",
        thumbnail:"https://img.youtube.com/vi/Z6CpE0iTvp0/maxresdefault.jpg"
      },
      {
        id: "28YQ2u-lfXU",
        description: "Ancient Shilo",
        thumbnail:"https://img.youtube.com/vi/28YQ2u-lfXU/maxresdefault.jpg"
      },
      {
        id: "oDSTmDO8hgc",
        description: "Dead Sea Overview",
        thumbnail:"https://img.youtube.com/vi/oDSTmDO8hgc/maxresdefault.jpg"
      },
      {
        id: "YoSaV1Rah78",
        description: "Tel Dan",
        thumbnail:"https://img.youtube.com/vi/YoSaV1Rah78/maxresdefault.jpg"
      },
      {
        id: "DB6spElU-f4",
        description: "Timna Park",
        thumbnail:"https://img.youtube.com/vi/DB6spElU-f4/maxresdefault.jpg"
      },
      {
        id: "RQjyttxrD8g",
        description: "Massada",
        thumbnail:"https://img.youtube.com/vi/RQjyttxrD8g/maxresdefault.jpg"
      },
      {
        id: "FhQIKxBhjjw",
        description: "Tel Moreshah",
        thumbnail:"https://img.youtube.com/vi/FhQIKxBhjjw/maxresdefault.jpg"
      },
      {
        id: "SLWOKcfAlFA",
        description: "Caesarea",
        thumbnail:"https://img.youtube.com/vi/SLWOKcfAlFA/maxresdefault.jpg"
      },
      {
        id: "T3you_Z12Xo",
        description: "Western Wall Tunnel Tour",
        thumbnail:"https://img.youtube.com/vi/T3you_Z12Xo/maxresdefault.jpg"
      },
      {
        id: "BIuFLr3oH-8",
        description: "Jaffa Port",
        thumbnail:"https://img.youtube.com/vi/BIuFLr3oH-8/maxresdefault.jpg"
      },
      {
        id: "azPZZBjG30g",
        description: "Tel Be'er Sheva",
        thumbnail:"https://img.youtube.com/vi/azPZZBjG30g/maxresdefault.jpg"
      },
      {
        id: "sWrqSfLoMZE",
        description: "Yad Vashem- A Mamorial to the Holocaust",
        thumbnail:"https://img.youtube.com/vi/sWrqSfLoMZE/maxresdefault.jpg"
      },
      {
        id: "PVRxfTyMBX0",
        description: "Midras Ruins",
        thumbnail:"https://img.youtube.com/vi/PVRxfTyMBX0/maxresdefault.jpg"
      },
      {
        id: "STV_RKopmME",
        description: "Beit Shean",
        thumbnail:"https://img.youtube.com/vi/STV_RKopmME/maxresdefault.jpg"
      },
      {
        id: "WDmVIZTCN4c",
        description: "Herodion",
        thumbnail:"https://img.youtube.com/vi/WDmVIZTCN4c/maxresdefault.jpg"
      },
      {
        id: "9KpTSe9Q6uw",
        description: "Korazim",
        thumbnail:"https://img.youtube.com/vi/9KpTSe9Q6uw/maxresdefault.jpg"
      },
      {
        id: "A9c2VMG_egA",
        description: "Mahane Yehuda",
        thumbnail:"https://img.youtube.com/vi/A9c2VMG_egA/maxresdefault.jpg"
      },
      {
        id: "fqbjc7wCnIY",
        description: "Western Wall Great Bridge Tunnel Tour",
        thumbnail:"https://img.youtube.com/vi/fqbjc7wCnIY/maxresdefault.jpg"
      },
      {
        id: "4pmMDjZ-7-s",
        description: "Zedekiah's Cave",
        thumbnail:"https://img.youtube.com/vi/4pmMDjZ-7-s/maxresdefault.jpg"
      },
      {
        id: "VsxZdALqGBo",
        description: "The Jordan River Valley",
        thumbnail:"https://img.youtube.com/vi/VsxZdALqGBo/maxresdefault.jpg"
      },
      {
        id: "FCTzmMmZAIA",
        description: "Old City Ramparts Walk",
        thumbnail:"https://img.youtube.com/vi/FCTzmMmZAIA/maxresdefault.jpg"
      },
      {
        id: "4DS0n2kWxxg",
        description: "The City of Sderot",
        thumbnail:"https://img.youtube.com/vi/W7vqt7-Pvxw/maxresdefault.jpg"
      },
      {
        id: "W7vqt7-Pvxw",
        description: "Ein Gedi",
        thumbnail:"https://img.youtube.com/vi/W7vqt7-Pvxw/maxresdefault.jpg"
      },
      {
        id: "11h2peSJmHY",
        description: "The Jewish Quarter of the Old City of Jerusalem",
        thumbnail:"https://img.youtube.com/vi/11h2peSJmHY/maxresdefault.jpg"
      },
      {
        id: "Aq9c_mkRfns",
        description: "Sussita",
        thumbnail:"https://img.youtube.com/vi/Aq9c_mkRfns/maxresdefault.jpg"
      }
    // Add more video data here
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 1500,
    autoplaySpeed: 6000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      }
    ]
  };

  const openVideoPopup = (videoId) => {
    setSelectedVideo(videoId);
  };

  const closeVideoPopup = () => {
    setSelectedVideo(null);
  };

  return (
    <div>
      <Slider {...settings}>
        {videos.map((video) => (
          <div key={video.id} className='ac-holyland-video'>
            <div
              className="video-slide"
            //   style={{ backgroundImage: `url(${video.thumbnail})`, width:'100%', height:'20vw' }}
              onClick={() => openVideoPopup(video.id)}
            >
            <img src={video.thumbnail} alt="" className='ac-bg-youtube'/>
              <div className="play-icon">
                {/* <img src="https://holyland.israel.travel/assets/img/Videos/play.png" alt="Play Icon" /> */}
                <Img desktopImg={"Videos/play.png"} /> 
              </div>
            </div>
            <h3 className="video-description">{video.description}</h3>
          </div>
        ))}
      </Slider>

      {selectedVideo && (
        <div className="video-popup-overlay" onClick={closeVideoPopup}>
          <div className="ac-close-wrapper">
            <button onClick={closeVideoPopup}>
              <span>+</span>
            </button>
          </div>
          <div className="video-popup">
            <iframe
              title="YouTube Video"
              width="560"
              height="315"
              src={`https://www.youtube.com/embed/${selectedVideo}`}
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      )}
    </div>
  );
};

export default HolylandYoutube;



// WEBPACK FOOTER //
// ./src/Components/HolylandYoutube/HolylandYoutube.js